import moment from "moment"

export const formatDate = (timestamp: string) => moment(timestamp).format('MMM D, YYYY')

export const fromNow = (timestamp: string) => moment(timestamp).fromNow()
